module.exports = __webpack_public_path__ + "img/Wp_2006.0e07c2d7.png";